(function() {
    'use strict';

    angular.module('order').controller('OrderProductFileModalController', OrderProductFileModalController);

    OrderProductFileModalController.$inject = [
        '$uibModalInstance',
        '$timeout',
        'orderProduct',
        'notificationSrvc',
        'errorNotificationSrvc',
        'orderProductFileDataSrvc'
    ];

    function OrderProductFileModalController(
        $uibModalInstance, $timeout, orderProduct, notificationSrvc, errorNotificationSrvc, orderProductFileDataSrvc
    ) {
        var self = this;

        self.orderProduct = orderProduct;
        self.orderProductFile = orderProduct.product_file;

        self.closeModal = closeModal;
        self.submitForm = submitForm;
        self.cleanErrors = cleanErrors;
        self.isPreflightInProgress = isPreflightInProgress;
        self.getOrderProductFileData = getOrderProductFileData;
        self.awaitPreflightDone = awaitPreflightDone;

        self.serverErrors = {
            order_product: []
        }

        self.modelData = {
            file: null,
        };

        function submitForm(){
            self.requestData = {
                order_product: orderProduct.pk
            };

            if (orderProduct.is_booklet_uv){
                self.requestData['client_cover_file'] = self.modelData.file
            } else {
                self.requestData['client_file'] = self.modelData.file
            }

            if (self.modelData.file !== null) {
                if (self.orderProductFile) {
                    removeFileForReplace(self.orderProductFile, createFile);
                } else {
                    createFile();
                }
            }
        }

        function createFile(){
            orderProductFileDataSrvc.create(self.requestData).$promise.then(
                function (response) {
                    self.orderProductFile = response;
                    self.awaitPreflightDone(self.orderProductFile)
                    self.modelData.file = null;
                    notificationSrvc.notification('success', 'Dodano plik projektowy do pozycji zamówienia');
                },
                function (response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            )
        }

        function removeFileForReplace(orderProductFile, callback) {
            return orderProductFileDataSrvc.delete({
                pk: orderProductFile.pk
            }).$promise.then(
                function(response) {
                    orderProductFile = null;

                    if (typeof callback === 'function'){
                        callback();
                    }
                },
                function(response) {
                    orderProductFile = null;
                }
            );
        }

        function getOrderProductFileData(orderProductFile, callback){
            return orderProductFileDataSrvc.get({pk: orderProductFile.pk}).$promise.then(
                function (response) {
                    self.orderProductFile = response;

                    if (callback){
                        callback(self.orderProductFile);
                    }
                },
                function (response) {
                    notificationSrvc.notification("error", 'Błąd podczas pobiernia danych pliku');
                }
            )
        }

        function isPreflightInProgress(orderProductFile){
            return orderProductFile && orderProductFile.preflight_status.status_code === null;
        }

        function awaitPreflightDone(orderProductFile){
            if (self.isPreflightInProgress(orderProductFile)){
                $timeout(function() {
                    self.getOrderProductFileData(orderProductFile, self.awaitPreflightDone);
                }, 3000);

            } else {
                notificationSrvc.notification("success", 'Zakończono proces weryfikacji pliku');
                $timeout(function() {
                    $uibModalInstance.close(self.orderProduct);
                }, 500)
            }
        }

        function closeModal() {
            $uibModalInstance.close(self.orderProduct);
            // $uibModalInstance.dismiss('cancel');
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
